import { Component, Input, OnInit, SimpleChanges,ChangeDetectorRef } from '@angular/core';
import { AuthService, ConstantService, HelperService, ApiService, PaginationService } from '../../core/services';

@Component({
  selector: 'app-music-player',
  templateUrl: './music-player.component.html',
  styleUrls: ['./music-player.component.css']
})
export class MusicPlayerComponent implements OnInit {

  @Input() audioData;
  audio: any;
  audioFile:any;

  public loadScript() {
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('id') != null && scripts[i].getAttribute('id').includes("music-player.js") ) {
        isFound = true;
      }
    }

    if (!isFound) {
      var dynamicScripts = ["assets/js/music-player.js"];
      // var dynamicScripts = ["assets/js/mediaelement/mediaelement-and-player.min.js","assets/js/mediaelement/changespeed.js","assets/js/mediaelement/jump-forward.min.js","assets/js/mediaelement/skip-back.min.js","assets/js/music-player.js"];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.setAttribute('id', 'musicPlayer');
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  }

  constructor(    private helperSvc: HelperService,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.loadScript();

  }

  ngOnChanges(changes: SimpleChanges) {
    // this.audioData.audio = '';

    let audioElement:any =  document.getElementById("audio-ele");

    if (changes["audioData"]) {
      this.audioFile = {};
      this.changeDetectorRef.detectChanges();
      this.audioFile = this.audioData;
      audioElement.src = this.audioData.audio;
      audioElement.pause();
      setTimeout(() => {
        audioElement.play();
      }, 150);
  
    }

  }

}
